import type { SearchIndex } from 'algoliasearch';
import algoliasearch from 'algoliasearch';
import { getEnvironment, PRODUCTION } from '@atlassian/temp-shared';
import { ALGOLIA_APP_ID, ALGOLIA_APP_KEY } from '@css-xp/ppc-constants';

export const algoliaClient = algoliasearch(ALGOLIA_APP_ID, ALGOLIA_APP_KEY);

export const getIndexInAlgolia = (isDesignIteration1Enabled = false): SearchIndex => {
  const env = getEnvironment();
  // More context on this - https://atlassian.slack.com/archives/C03K4EEF6FP/p1741169362909569
  const correctStageEnvForAlgolia = isDesignIteration1Enabled ? 'stg' : 'uat';
  const algoliaIndexEnv = env === PRODUCTION ? 'prod' : correctStageEnvForAlgolia;
  const algoliaIndex = `product_help_${algoliaIndexEnv}`;
  return algoliaClient.initIndex(algoliaIndex);
};
